<template>
  <div class="list">
    <Loading v-show="loading"></Loading>
    <div class="header">
       <a id="close" v-on:click="back()"><img  src="../../assets/left.png" alt=""></a>
       <p id="title">Shopping List</p><br>
      <p id="title">{{ title }}</p>
    </div>
    <img src="../../assets/price.jpg" class="mainImg">
    <div class="menu-inner">
      <p id="title">Menu</p>
      <p id="description">3 days</p>
      <div class="bar">
        <table>
          <tr>
            <th class="left">DAY1</th>
            <th class="right" v-if="isDay1"><button class="openButton" v-on:click="closeDay1()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openDay1()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="day1-inner" v-show="isDay1">
        <ul>
          <li v-for="r of firstRecipes"  :key="r">
            {{ r.name }}
          </li>
        </ul>
      </div>
      <div class="bar">
        <table>
          <tr>
            <th class="left">DAY2</th>
            <th class="right" v-if="isDay2"><button class="openButton" v-on:click="closeDay2()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openDay2()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="day2-inner" v-show="isDay2">
        <ul>
          <li v-for="r of secondRecipes"  :key="r">
            {{ r.name }}
          </li>
        </ul>
      </div>
      <div class="bar">
        <table>
          <tr>
            <th class="left">DAY3</th>
            <th class="right" v-if="isDay3"><button class="openButton" v-on:click="closeDay3()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openDay3()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="day3-inner" v-show="isDay3">
        <ul>
          <li v-for="r of thirdRecipes"  :key="r">
            {{ r.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="ingredient-inner">
      <p id="title">Shopping List</p>
      <p id="description">{{ ingredientNum }} items</p>
      <div class="bar" v-if="fruitCategories.length > 0">
        <table>
          <tr>
            <th class="left">果物</th>
            <th class="right" v-if="isFruit"><button class="openButton" v-on:click="closeFruit()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openFruit()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="fruit-inner" v-show="isFruit">
        <ul>
          <li v-for="f of fruitCategories"  :key="f">
            <table>
              <tr>
                <th class="left">{{ f.name }}</th>
                <th class="right">{{ f.amount }} {{ f.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="bar" v-if="vegitableCategories.length > 0">
        <table>
          <tr>
            <th class="left">野菜</th>
            <th class="right" v-if="isVegitable"><button class="openButton" v-on:click="closeVegitable()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openVegitable()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="vegitable-inner" v-show="isVegitable">
        <ul>
          <li v-for="v of vegitableCategories"  :key="v">
            <table>
              <tr>
                <th class="left">{{ v.name }}</th>
                <th class="right">{{ v.amount }} {{ v.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="bar" v-if="meatCategories.length > 0">
        <table>
          <tr>
            <th class="left">肉</th>
            <th class="right" v-if="isMeat"><button class="openButton" v-on:click="closeMeat()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openMeat()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="meat-inner" v-show="isMeat">
        <ul>
          <li v-for="m of meatCategories"  :key="m">
            <table>
              <tr>
                <th class="left">{{ m.name }}</th>
                <th class="right">{{ m.amount }} {{ m.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="bar" v-if="fishCategories.length > 0">
        <table>
          <tr>
            <th class="left">魚</th>
            <th class="right" v-if="isFish"><button class="openButton" v-on:click="closeFish()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openFish()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="fish-inner" v-show="isFish">
        <ul>
          <li v-for="f of fishCategories"  :key="f">
            <table>
              <tr>
                <th class="left">{{ f.name }}</th>
                <th class="right">{{ f.amount }} {{ f.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="bar" v-if="dairyCategories.length > 0">
        <table>
          <tr>
            <th class="left">乳製品</th>
            <th class="right" v-if="isDairy"><button class="openButton" v-on:click="closeDairy()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openDairy()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="dairy-inner" v-show="isDairy">
        <ul>
          <li v-for="d of dairyCategories"  :key="d">
            <table>
              <tr>
                <th class="left">{{ d.name }}</th>
                <th class="right">{{ d.amount }} {{ d.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="bar" v-if="cerealsCategories.length > 0">
        <table>
          <tr>
            <th class="left">穀類</th>
            <th class="right" v-if="isCereal"><button class="openButton" v-on:click="closeCereal()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openCereal()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="cereal-inner" v-show="isCereal">
        <ul>
          <li v-for="c of cerealsCategories"  :key="c">
            <table>
              <tr>
                <th class="left">{{ c.name }}</th>
                <th class="right">{{ c.amount }} {{ c.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="bar" v-if="seasoningCategories.length > 0">
        <table>
          <tr>
            <th class="left">調味料</th>
            <th class="right" v-if="isSeasoning"><button class="openButton" v-on:click="closeSeasoning()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openSeasoning()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="seasoning-inner" v-show="isSeasoning">
        <ul>
          <li v-for="s of seasoningCategories"  :key="s">
            <table>
              <tr>
                <th class="left">{{ s.name }}</th>
                <th class="right">{{ s.amount }} {{ s.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="bar" v-if="otherCategories.length > 0">
        <table>
          <tr>
            <th class="left">その他</th>
            <th class="right" v-if="isOther"><button class="openButton" v-on:click="closeOther()"><img  src="../../assets/top.png" alt=""></button></th>
            <th class="right" v-else ><button class="openButton" v-on:click="openOther()"><img  src="../../assets/bottom2.png" alt=""></button></th>
          </tr>
        </table>
      </div>
      <div class="other-inner" v-show="isOther">
        <ul>
          <li v-for="o of otherCategories"  :key="o">
            <table>
              <tr>
                <th class="left">{{ o.name }}</th>
                <th class="right">{{ o.amount }} {{ o.unit }}</th>
              </tr>
            </table>
          </li>
        </ul>
      </div>
    </div>

<!--
    <div class="content" v-for="r of recipe"  :key="r">
      <div class="header">
        <p id="title">{{ r.name }}</p>
        <a id="close" v-on:click="unfavorite()"><img  src="../../assets/left.png" alt=""></a>
      </div>
      <div class="first">
        <div class="flexbox">
          <section class="main">
            <img v-bind:src="r.thumbnail">
            <p>{{ r.time }}min | {{ r.kcal }}Kcal</p>
            <table>
              <tr>
                <th>Protein</th>
                <th>Fat</th>
                <th>Carbs</th>
              </tr>
              <tr>
                <td>{{ r.protein }}g</td>
                <td>{{ r.fat }}g</td>
                <td>{{ r.carbs }}g</td>
              </tr>
            </table>
          </section>
          <section class="side">
            <p>+α</p>
            <p>{{ r.recommend }}</p>
          </section>
        </div>
      </div>
      <div class="bar">
        <table>
          <tr>
            <th class="left">INGREDIENTS</th>
            <th class="right">{{ r.ingredientAmount }} items</th>
          </tr>
        </table>
      </div>
      <div class="recipe-content">
        <table v-show="isRecipeOpen">
          <tr>
            <td class="maintitle"></td>
            <td class="maintitle"></td>
            <td class="subtitle">Calories</td>
            <td class="subtitle">P</td>
            <td class="subtitle">F</td>
            <td class="subtitle">C</td>
          </tr>
          <tr v-for="ingredient of r.ingredients"  :key="ingredient">
            <td class="maintitle">{{ ingredient.name }}</td>
            <td class="maintitle">{{ ingredient.amount }}</td>
            <td class="subtitle">{{ ingredient.calory }}Kcal</td>
            <td class="subtitle">{{ ingredient.protein }}g</td>
            <td class="subtitle">{{ ingredient.fat }}g</td>
            <td class="subtitle">{{ ingredient.carbs }}g</td>
          </tr>
        </table>
        <table v-show="isRecipeClose">
          <tr>
            <td class="maintitle"></td>
            <td class="maintitle"></td>
            <td class="subtitle">Calories</td>
            <td class="subtitle">P</td>
            <td class="subtitle">F</td>
            <td class="subtitle">C</td>
          </tr>
          <tr v-for="ingredient of r.topIngredients"  :key="ingredient">
            <td class="maintitle">{{ ingredient.name }}</td>
            <td class="maintitle">{{ ingredient.amount }}</td>
            <td class="subtitle">{{ ingredient.calory }}Kcal</td>
            <td class="subtitle">{{ ingredient.protein }}g</td>
            <td class="subtitle">{{ ingredient.fat }}g</td>
            <td class="subtitle">{{ ingredient.carbs }}g</td>
          </tr>
          <tr><td colspan="6"><button class="openButton" v-on:click="openRecipe()"><img  src="../../assets/bottom.png" alt=""></button></td></tr>
          </table>
      </div>
      <div class="bar">
        <table>
          <tr>
            <th class="left">PREPARATION</th>
            <th class="right">{{ r.preparationAmount }} steps</th>
          </tr>
        </table>
      </div>
      <div class="preparation-content">
        <table v-show="isPreparationOpen">
          <tr v-for="(preparation, index) in r.preparation">
            <td class="process">{{ index+1 }}、{{ preparation }}</td>
          </tr>
        </table>
        <table v-show="isPreparationClose">
          <tr v-for="(preparation, index) in r.topPreparation">
            <td class="process">{{ index+1 }}、{{ preparation }}</td>
          </tr>
          <tr><td><button class="openButton" v-on:click="openPreparation()"><img  src="../../assets/bottom.png" alt=""></button></td></tr>
          </table>
      </div>
    </div>-->
  </div>
</template>
<style scoped>
.list{
  padding-top: 36px;
  padding-bottom: 36px;
}

.list .header {
  position: relative;
  height: 100px;
  width: 60%;
  margin:0 auto;
  
}
.list .mainImg{
  width: 300px;
}
.list .favorite {
  position: absolute;
  right: 0;
  background: transparent;
  border:0;
}
.openButton{
  background: transparent;
  border:0;
  position: relative;
}
.list .openButton img {
  width: 18px;
  position: absolute;
  background: #CCCCCC;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  /*-webkit- transform: translateY(-50%) translateX(-50%);*/
}
.list .favorite img{
  width: 36px;
  margin-top: 32px;
}
.list #title{
  display: inline-block;
  margin:0 auto;
  line-height: 50px;

}
.list #close {
  position: absolute;
  left: 0;
}
.list #close img{
  width: 36px;
  margin-top: 32px;
}
.list .bar{
  background: #CCCCCC;
  height: 48px;
}
.list .bar table{
  width: 60%;
  margin: 0 auto;
}
.list .bar .left{
  text-align: left;
  width: 50%;
}
.list .bar .right{
  text-align: right;
  width: 50%;
}
.list .recipe-content table{
  margin: 16px auto;
  width: 50%;
}
.list .preparation-content table{
  margin: 16px auto;
  width: 50%;
}
.list .preparation-content .process{
  text-align: left;
}
.list .recipe-content .maintitle{
  width: 30%;
  text-align: left;
}
.list .recipe-content .subtitle{
  text-align: center;
  width: 10%;
}
.list ul{
  padding-left: 0px;
}
.main {
  width: 40%;
  padding:5%;
}
.main img{
  height: 200px;
  width: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.main table{
  width: 100%;
}
.side {
  padding:5%;
  width: 60%;
}
.side p{
  text-align: left;
}
.main,
.side {
}
.list .day1-inner{
  width: 60%;
  margin:0 auto;

}
.list .day2-inner{
  width: 60%;
  margin:0 auto;
}
.list .day3-inner{
  width: 60%;
  margin:0 auto;
}
.list .day1-inner li{
  text-align: left;
  list-style: none;
}
.list .day2-inner li{
  text-align: left;
  list-style: none;
}
.list .day3-inner li{
  text-align: left;
  list-style: none;
}
.ingredient-inner table{
  width: 100%;
}
.ingredient-inner .left {
  width: 50%;
  text-align: left;
}
.ingredient-inner .right {
  width: 50%;
  text-align: right;
}
.ingredient-inner .fruit-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .fruit-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner .vegitable-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .vegitable-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner .meat-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .meat-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner .fish-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .fish-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner .dairy-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .dairy-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner .cereal-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .cereal-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner .seasoning-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .seasoning-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner .other-inner {
    width: 60%;
    margin: 0 auto;
}
.ingredient-inner .other-inner ul{
  padding-left: 0px;
  list-style: none;
}
.ingredient-inner{
  margin-bottom: 5%;
}
/* Responsive */
@media ( min-width : 600px ){
    .flexbox {
      display: -webkit-flex;
      display: flex;
      margin:0 auto;
      width: 60%;
    }
}
@media ( max-width : 780px ){
  .list .header {
    width: 90%;
  }
  .list .mainImg {
    width: 100%;
}
.list #title {
  margin-top: 16px;
    line-height: initial;
}
.list #description {
    margin:0px;
    margin-bottom: 16px;
}
.list .bar table {
    width: 90%;
}
.list .day1-inner {
  width: 90%;
}
.list .day2-inner {
  width: 90%;
}
.list .day3-inner {
  width: 90%;
}
.ingredient-inner .fruit-inner {
    width: 90%;
    margin: 0 auto;
}
.ingredient-inner .vegitable-inner {
    width: 90%;
    margin: 0 auto;
}
.ingredient-inner .meat-inner {
    width: 90%;
    margin: 0 auto;
}
.ingredient-inner .fish-inner {
    width: 90%;
    margin: 0 auto;
}
.ingredient-inner .dairy-inner {
    width: 90%;
    margin: 0 auto;
}
.ingredient-inner .cereal-inner {
    width: 90%;
    margin: 0 auto;
}
.ingredient-inner .seasoning-inner {
    width: 90%;
    margin: 0 auto;
}
.ingredient-inner .other-inner {
    width: 90%;
    margin: 0 auto;
}
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'List',
  components: {
    Loading
  },
  data () {
    return {
      userId: null,
      startDate: null,
      endDate: null,
      title: '',
      recipeId: null,
      db: null,
      loading: false,
      ingredientNum: null,
      recipes: [],
      firstRecipes: [],
      secondRecipes: [],
      thirdRecipes: [],
      fruitCategories: [],
      vegitableCategories: [],
      meatCategories: [],
      fishCategories: [],
      dairyCategories: [],
      cerealsCategories: [],
      seasoningCategories: [],
      otherCategories: [],
      vegitableCategoriesNum: 0,
      isDay1: false,
      isNoDay1: false,
      isDay2: false,
      isDay3: false,
      isFruit: false,
      isVegitable: false,
      isMeat: false,
      isFish: false,
      isDairy: false,
      isCereal: false,
      isSeasoning: false,
      isOther: false
    }
  },
  methods: {
    back: function () {
      location.href = '/today?startYear=' + this.startDate.getFullYear() + '&startMonth=' + this.startDate.getMonth() + '&startDate=' + this.startDate.getDate() + '&endYear=' + this.endDate.getFullYear() + '&endMonth=' + this.endDate.getMonth() +'&endDate=' + this.endDate.getDate() + '&userId=' + this.userId


    },
    getRecipes: function () {
      var exist = false
      this.loading = true
      let self = this
      var amount = 0
      var db = this.db
      this.recipes = []
      this.selectRecipes = []
      db.collection('recipes').where('date', '>=', new Date(this.startDate)).where('date', '<', new Date(this.endDate)).get().then(function (querySnapshot) {
        console.log(querySnapshot.docs.length)
        querySnapshot.forEach(function (doc) {
          exist = true
          var hash = {}
          hash['id'] = doc.id
          hash['name'] = doc.get('name')
          hash['ingredients'] = doc.get('ingredients')
          self.recipes.push(hash)
          if (amount < 4) {
            var hash = {}
            hash['id'] = doc.id
            hash['name'] = doc.get('name')
            self.firstRecipes.push(hash)
          }else if (amount < 8) {
            var hash = {}
            hash['id'] = doc.id
            hash['name'] = doc.get('name')
            self.secondRecipes.push(hash)
          } else {
            var hash = {}
            hash['id'] = doc.id
            hash['name'] = doc.get('name')
            self.thirdRecipes.push(hash)
          }
          
          if (amount === querySnapshot.docs.length-1) {
            // self.loading = false
            console.log('fdsfsffefefe')
            self.getIngredient()
          }
          amount++
        })
        if (!exist) {
          alert('レシピは存在しません。')
          self.back()
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('レシピの取得に失敗しました。エラーです。')
          self.back()
        })

    },
    getIngredient: function () {

      // レシピの各Ingerdientにある材料情報からカテゴリごとに振り分ける
      let self = this
      for (let num = 0; num < this.recipes.length; num++) {

        for (let n = 0; n < this.recipes[num].ingredients.length; n++) {

          // カテゴリで条件分岐
          switch (this.recipes[num].ingredients[n].category){
          case 0:
            // 例) 果物カテゴリ配列に素材名と数量・単位ハッシュを登録　既に同じ名前がある場合は、数量に足しこむ

            //既に同じ名前がある場合は、数量に足しこむ(ハッシュの更新)
            const index = self.fruitCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.fruitCategories.push(hash)
            } else {
              //ハッシュ更新
              self.fruitCategories[index].amount = self.fruitCategories[index].amount + this.recipes[num].ingredients[n].amount
            }
            
            break;
          case 1:

            const index1 = self.vegitableCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index1 === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.vegitableCategories.push(hash)
            } else {
              //ハッシュ更新
              self.vegitableCategories[index1].amount = self.vegitableCategories[index1].amount + this.recipes[num].ingredients[n].amount
            }
            
            break;
          case 2:
            const index2 = self.meatCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index2 === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.meatCategories.push(hash)
            } else {
              //ハッシュ更新
              self.meatCategories[index2].amount = self.meatCategories[index2].amount + this.recipes[num].ingredients[n].amount
            }
            break;
          case 3:
            const index3 = self.fishCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index3 === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.fishCategories.push(hash)
            } else {
              //ハッシュ更新
              self.fishCategories[index3].amount = self.fishCategories[index3].amount + this.recipes[num].ingredients[n].amount
            }
            break;
          case 4:
            const index4 = self.dairyCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index4 === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.dairyCategories.push(hash)
            } else {
              //ハッシュ更新
              self.dairyCategories[index4].amount = self.dairyCategories[index4].amount + this.recipes[num].ingredients[n].amount
            }
            break;
          case 5:
            const index5 = self.cerealsCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index5 === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.cerealsCategories.push(hash)
            } else {
              //ハッシュ更新
              self.cerealsCategories[index5].amount = self.cerealsCategories[index5].amount + this.recipes[num].ingredients[n].amount
            }
            break;
          case 6:
            const index6 = self.seasoningCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index6 === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.seasoningCategories.push(hash)
            } else {
              //ハッシュ更新
              self.seasoningCategories[index6].amount = self.seasoningCategories[index6].amount + this.recipes[num].ingredients[n].amount
            }
            break;
          case 7:
            const index7 = self.otherCategories.findIndex((c) => c.name === this.recipes[num].ingredients[n].name)
            if (index7 === -1) {
              var hash = {}
              hash['name'] = this.recipes[num].ingredients[n].name
              hash['amount'] = this.recipes[num].ingredients[n].amount
              hash['unit'] = this.getUnit(this.recipes[num].ingredients[n].unit)
              self.otherCategories.push(hash)
            } else {
              //ハッシュ更新
              self.otherCategories[index7].amount = self.otherCategories[index7].amount + this.recipes[num].ingredients[n].amount
            }
            break;
          
          } 
        }

        if (num === this.recipes.length-1) {

          // 合計素材数を計算
          self.ingredientNum = self.fruitCategories.length +  self.vegitableCategories.length + self.meatCategories.length + self.fishCategories.length + self.cerealsCategories.length + self.dairyCategories.length + self.seasoningCategories.length + self.otherCategories.length



          self.loading = false
        }
        
      }
    },
    getUnit: function (num) {
      switch (num){
          case 0:
           return '個'
          case 1:
           return 'グラム'
          case 2:
           return 'リットル'
      }
    },
    getMMDDStringFromDate: function (date) {
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + date.getDate()).slice(-2)
      var result = m + '/' + d
      return result
    },
    getYesterday: function (date) {
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var day = date.getDate() - 1
      var d = ('00' + day).slice(-2)
      var result = m + '/' + d
      return result
    },
    openDay1: function () {
      $('.day1-inner').slideToggle(300);
      this.isDay1 = true
      //ボタンを変更
    },
    openDay2: function () {
      $('.day2-inner').slideToggle(300);
      this.isDay2 = true
    },
    openDay3: function () {
      $('.day3-inner').slideToggle(300);
      this.isDay3 = true
    },
    openFruit: function () {
      $('.fruit-inner').slideToggle(300);
      this.isFruit = true
    },
    openVegitable: function () {
      $('.vegitable-inner').slideToggle(300);
      this.isVegitable = true
    },
    openMeat: function () {
      $('.meat-inner').slideToggle(300);
      this.isMeat = true
    },
    openFish: function () {
      $('.fish-inner').slideToggle(300);
      this.isFish = true
    },
    openDairy: function () {
      $('.dairy-inner').slideToggle(300);
      this.isDairy = true
    },
    openCereal: function () {
      $('.cereal-inner').slideToggle(300);
      this.isCereal = true
    },
    openSeasoning: function () {
      $('.seasoning-inner').slideToggle(300);
      this.isSeasoning = true
    },
    openOther: function () {
      $('.other-inner').slideToggle(300);
      this.isOther = true
    },
    closeDay1: function () {
      this.isDay1 = false
      $('.day1-inner').slideToggle(300);
      //ボタンを変更
    },
    closeDay2: function () {
      
      this.isDay2 = false
      $('.day2-inner').slideToggle(300);
    },
    closeDay3: function () {
      
      this.isDay3 = false
      $('.day3-inner').slideToggle(300);
    },
    closeFruit: function () {
      this.isFruit = false
      $('.fruit-inner').slideToggle(300);
    },
    closeVegitable: function () {
      this.isVegitable= false
      $('.vegitable-inner').slideToggle(300);
    },
    closeMeat: function () {
      this.isMeat= false
      $('.meat-inner').slideToggle(300);
    },
    closeFish: function () {
      this.isFish = false
      $('.fish-inner').slideToggle(300);
    },
    closeDairy: function () {
      this.isDairy = false
      $('.dairy-inner').slideToggle(300);
    },
    closeCereal: function () {
      this.isCereal = false
      $('.cereal-inner').slideToggle(300);
    },
    closeSeasoning: function () {
      this.isSeasoning = false
      $('.seasoning-inner').slideToggle(300);
    },
    closeOther: function () {
      this.isOther = false
      $('.other-inner').slideToggle(300);
    }

  },
  created: function () {
    // Planを取得
    let self = this
    this.db = firebase.firestore()
    firebase.auth().languageCode = 'jp'
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.userId = result['userId']
    var startYear = parseInt(result['startYear'], 10)
    var startMonth = parseInt(result['startMonth'], 10)
    var startDate = parseInt(result['startDate'], 10)
    this.startDate = new Date(startYear, startMonth, startDate, 0, 0, 0)
    var endYear = parseInt(result['endYear'], 10)
    var endMonth = parseInt(result['endMonth'], 10)
    var endDate = parseInt(result['endDate'], 10)
    this.endDate = new Date(endYear, endMonth, endDate, 0, 0, 0)

    if (!this.userId) {
      alert('ユーザーが存在しません、。再度ログインしなおしてください。')
      location.href='/'
    } else {
      // タイトル作成
      console.log(this.startDate)
      console.log(this.endDate)
      this.title = this.getMMDDStringFromDate(this.startDate) + '〜' + this.getYesterday(this.endDate)

      //3日間のレシピ内容からから栄養等の情報を取得
      this.getRecipes()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/list/List.vue